import { Component, Input } from '@angular/core';
import { RouteSheetLocationDTO } from '../../../organisms/route-sheet/models/RouteSheetLocationDTO';
import { RouteSheetService } from '../../../organisms/route-sheet/service/RouteSheet.service';

@Component({
  selector: 'route-sheet-services-card',
  templateUrl: './services-card.component.html',
  styleUrls: ['./services-card.component.css']
})
export class RouteSheetServicesCardComponent {
  @Input() routeSheetLocation: RouteSheetLocationDTO;
  @Input() skeletonLoading: boolean = false;

  constructor(private routeSheetService: RouteSheetService) {}


}
